import { Component, Input, OnInit } from '@angular/core';
import { CoePeople } from 'src/app/model/coes/coe-people.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { StudentService } from '../../../service/student.service';

@Component({
    selector: 'view-child-demographic-parents',
    templateUrl: './view-child-demographic-parents.component.html',
    styleUrl: './view-child-demographic-parents.component.scss'
})
export class ViewChildDemographicParentsComponent implements OnInit {
    @Input() studentId!: number;

    parents: CoePeople[] = [];
    parentIds: string = '';

    isLoading: boolean = false;
    isSaving: boolean = false;

    promises: Array<any> = [];

    getPropertyPipe = new GetPropertyPipe();

    constructor(private studentService: StudentService) {}

    ngOnInit(): void {
        this.init();
    }

    init() {
        this.isLoading = true;

        this.getParents();
        Promise.all(this.promises).then((res) => {
            this.isLoading = false;
        });
    }

    getParents() {
        let deferred = new Promise((resolve, reject) => {
            this.studentService.getParents(this.studentId).subscribe((res) => {
                if (res.parents) {
                    this.parents = res.parents;
                    this.parentIds = this.parents.map((p) => p.ID).join(',');

                    this.parents.forEach((parent) => {
                        switch (parent.COE_PEOPLE_TYPE.ID) {
                            case 1: //Current Male Parent/Guardian
                                parent.COE_PEOPLE_TYPE.TYPE = 'Current Parent/Guardian 1';
                                break;
                            case 2: //Current Female Parent/Guardian
                                parent.COE_PEOPLE_TYPE.TYPE = 'Current Parent/Guardian 2';
                                break;
                            case 3: //Legal Father
                                parent.COE_PEOPLE_TYPE.TYPE = 'Legal Parent/Guardian 1';
                                break;
                            case 4: //Legal Mother
                                parent.COE_PEOPLE_TYPE.TYPE = 'Legal Parent/Guardian 2';
                                break;
                        }
                    });

                    this.parents = res.parents.sort((n1: CoePeople, n2: CoePeople) => (n1.COE_PEOPLE_TYPE.TYPE! > n2.COE_PEOPLE_TYPE.TYPE! ? 1 : -1));

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    resolve('err');
                }
            });
        });

        this.promises.push(deferred);
    }
}
